module.exports = __webpack_public_path__ + "static/img/kf3.cab16748.png";